import { render, staticRenderFns } from "./WhatsappConfigPanel.vue?vue&type=template&id=e3145e02&scoped=true"
import script from "./WhatsappConfigPanel.vue?vue&type=script&lang=js"
export * from "./WhatsappConfigPanel.vue?vue&type=script&lang=js"
import style0 from "./WhatsappConfigPanel.vue?vue&type=style&index=0&id=e3145e02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3145e02",
  null
  
)

export default component.exports